// Risk-free-play game ids are set by aegis-svc (`Game`, `buildMultiplayerGameId`).
// Multiplayer ids are MULTIPLAYER_<gameNumber>_<roomNumber>; the game numbers
// follow GAME_TYPE in multiplayer-dapp.
const GAME_NAMES = {
  DCF: 'Coin Flip',
  DCD: 'Coin Dozer',
  DS: 'Degen Spin',
  MULTIPLAYER: 'Multiplayer',
};

const MULTIPLAYER_GAME_NAMES = {
  1: 'Multiplayer Coin Flip',
  2: 'Crash',
  3: 'Towers',
  501: 'Dozer',
};

const MULTIPLAYER_GAME_ID = /^MULTIPLAYER_(\d+)_\d+$/;

// Unknown ids fall through unchanged so a new game still shows something.
export const gameName = gameId => {
  if (!gameId) return '';
  const multiplayer = MULTIPLAYER_GAME_ID.exec(gameId);
  if (multiplayer) return MULTIPLAYER_GAME_NAMES[multiplayer[1]] ?? gameId;
  return GAME_NAMES[gameId] ?? gameId;
};
